<script>
import { PodcastCategory } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Podcast Category',
      addRoute: { name: 'Add Podcast Category' },
      verboseName: 'Kategoria podcastu',
      verboseNamePlural: 'Kategorie podcastu',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'title_pl', label: 'tytuł (pl)' },
        { prop: 'title_en', label: 'tytuł (en)' },
      ]
    }
  },
  computed: {
    service() {
      return PodcastCategory
    }
  }
}
</script>
